module.exports = __webpack_public_path__ + "img/finance.a83e5a7e.png";